export default function AboutUs(){
    return(
        <>
        <section
  className="page-title"
  style={{
    backgroundImage: "url(/assets/images/bg/02.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <h1>
         About Us
        </h1>
        <nav aria-label="breadcrumb" class="page-breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="/">
                <i class="bi bi-house-door me-1"></i>Home</a>
            </li>
            
            <li class="breadcrumb-item active" aria-current="page">About Us</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div id="particles-js"></div>
</section>
        
        <section class="pt">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <img src="assets/images/about/01.jpg" class="img-fluid rounded" alt=""/>
      </div>
      <div class="col-lg-6 col-md-12 mt-8 mt-lg-0">
        <div class="theme-title">
          <h6>What We Do</h6>
          <h2>Strong Values That Bring <span>Great People Together.</span>
          </h2>
          <p>We redefine the boundaries of scientific exploration Our state-of-the-art laboratory and dedicated research teams are committed to advancing knowledge.</p>
        </div>
        <div class="featured-item style-6 mb-5">
          <div class="featured-icon">
            <i class="flaticon flaticon-check-mark"></i>
          </div>
          <div class="featured-desc">
            <div class="featured-title">
              <h4>10+ Research Center</h4>
            </div>
            <p>Protects your data with military-grade encryption.</p>
          </div>
        </div>
        <div class="featured-item style-6 mb-5">
          <div class="featured-icon">
            <i class="flaticon flaticon-check-mark"></i>
          </div>
          <div class="featured-desc">
            <div class="featured-title">
              <h4>Free Pick Up & Delivery</h4>
            </div>
            <p>Protects your data with military-grade encryption.</p>
          </div>
        </div>
        <div class="featured-item style-6">
          <div class="featured-icon">
            <i class="flaticon flaticon-check-mark"></i>
          </div>
          <div class="featured-desc">
            <div class="featured-title">
              <h4>24/7 Support Assistant</h4>
            </div>
            <p>Protects your data with military-grade encryption.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


  <div class="container mb-5">
    <div class="row align-items-center justify-content-between">
     
      <div class="col-lg-6 col-12 mt-6 mt-lg-0 ps-lg-8">
        <div class="theme-title">
         
          <h2>Experiment With The Best <span>Lab Test And Service</span></h2>
          <p>Our journey is a testament to our pursuit of a healthier tomorrow, as we are steadfast in our mission to ensure progressive and advanced healthcare solutions for patients in need. Our commitment is to enhance the quality of living while building an engaging, enriching, and empowering culture at Olympians.</p>
        </div>
        <div class="row mt-4 mb-3">
          <div class="col-md-6">
            <ul class="list-unstyled list-icon style-2 mb-0">
              <li class="mb-3">
                <i class="bi bi-check2-all"></i> Toxicological assessment
              </li>
              <li>
                <i class="bi bi-check2-all"></i> Diagnostic research Facility
              </li>
            </ul>
          </div>
          <div class="col-md-6">
            <ul class="list-unstyled list-icon style-2 mb-0">
              <li class="mb-3">
                <i class="bi bi-check2-all"></i> Basic Pathology Testing
              </li>
              <li class="mb-3">
                <i class="bi bi-check2-all"></i> Biological evaluation
              </li>
            </ul>
          </div>
        </div>
        <hr class="border border-light"/>
        <div class="row mt-4 mb-3">
          <div class="col-md-6">
           <a class="themeht-btn primary-btn" href="about-us.html">More About Us</a>
          </div>
          {/* <div class="col-md-6 mt-3 mt-md-0">
            <div class="d-flex align-items-center">
              <div class="flex-shrink-0">
                <img class="rounded-circle" src="assets/images/about-thumb.jpg" alt="..."/>
              </div>
              <div class="flex-grow-1 ms-3">
                <h6 class="mb-0">Dr. Abigail George</h6>
                <label class="text-theme">Laboratory Specialist</label>
              </div>
            </div>
          </div> */}
        </div>
       
      </div>
       <div class="col-lg-6 col-12">
        <div class="row g-0">
          <div class="col-md-6 mb-4 mb-md-0">
            <div class="about1-img-shape w-100 h-100">
          <img class="img-fluid" src="assets/images/about/01.jpg" alt=""/>
        </div>
          </div>
          <div class="col-md-6 mb-4 mb-md-0">
            <div class="about1-img-shape w-100 h-100">
          <img class="img-fluid" src="assets/images/about/02.jpg" alt=""/>
        </div>
          </div>
        </div>
        <div class="row g-0 mt-md-n5 justify-content-center text-center">
          <div class="col-md-6">
            <div class="about1-img-shape w-100 h-100">
          <img class="img-fluid" src="assets/images/about/08.jpg" alt=""/>
        </div>
          </div>
        </div>
      </div>
    </div>
  </div>

        
        </>
    )
}